import React from 'react';
import { Form } from 'react-bootstrap';
import './SearchBar.css';

function SearchBar({
  searchTerm,
  setSearchTerm,
  placeholder = "Search for a unit # or specific issue",
}) {
  return (
    <div className="searchbar-wrapper">
      {/* Magnifying glass icon */}
      <i className="fa fa-search search-icon" aria-hidden="true"></i>
      
      <Form.Group controlId="unitSearch" className="m-0">
        <Form.Label className="visually-hidden">{placeholder}</Form.Label>
        <Form.Control
          type="text"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="searchbar-input"
        />
      </Form.Group>
    </div>
  );
}

export default SearchBar;
